import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { DrawsService } from '@/services/api/draws.service';
import { DrawSchedule } from '@/models/bank-models.model';
import { DrawEditorComponent } from './draw-editor.component';

@Component({
    selector: 'app-draw-schedules',
    imports: [
      CommonModule,
      TableModule,
      DialogModule,
      ButtonModule,
      DrawEditorComponent
    ],
    template: `
    <p-table 
[value]="drawDataService.drawData()" 
selectionMode="single" 
[(selection)]="selection" 
[tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
        <tr>
            <th>Schedule</th>
            <th>Events</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-schedule>
        <tr [pSelectableRow]="schedule">
            <td>{{ schedule.Title }}</td>
            <td>{{ schedule.Draws.length }}</td>
        </tr>
    </ng-template>
</p-table>
<p-dialog header="Draw Editor" [modal]="true"  [(visible)]="drawEditorVisible">
    <app-draw-editor></app-draw-editor>
</p-dialog>
    `
})
export class DrawSchedulesComponent {
  public drawDataService = inject(DrawsService);
  drawEditorVisible = false
  
  constructor() {
if(this.drawDataService.drawData().length === 0) {
  this.drawDataService.loadDraws();
}
  }

  get selection(): DrawSchedule | null {
    return this.drawDataService.selectedDraw();
  }

  set selection(draw: DrawSchedule | null) {
    console.log('selection', draw);
    this.drawDataService.setSelectedDraw(draw);
    this.drawEditorVisible = true;
  }

  onDrawEditorClose() {
    this.drawEditorVisible = false;
  }
}
